module.exports = __webpack_public_path__ + "img/radio-wai.c98b98ac.jpg";